<script setup lang="ts">
defineProps<{ data: SplitScreenProps; chapterIndex?: number; template?: 'page' | 'overlay' }>()
</script>

<template>
  <section
    class="relative flex flex-col"
    :class="{
      'bg-white': template !== 'page' && template !== 'overlay' && data.theme !== 'light-grey',
      'bg-light-grey':
        template === 'page' || (template !== 'overlay' && data.theme === 'light-grey'),
    }"
  >
    <div
      class="flex"
      :class="[
        data.layout === 'rightMedia'
          ? 'flex-col xl:flex-row'
          : 'flex-col-reverse xl:flex-row-reverse',
        data.theme === 'light-grey' ? 'bg-light-grey' : '',
      ]"
    >
      <div class="xl:gap-gap px-3 pt-25 pb-10 xl:grid xl:w-1/2 xl:grid-cols-6 xl:pt-32">
        <div class="col-span-full">
          <ElementsChapter
            v-if="data.trumpet && chapterIndex"
            class="pb-6 xl:pb-7"
            :chapter="data.trumpet"
            :index="chapterIndex"
          />
          <ElementsTitleRevealv2
            :title="data.title"
            class="font-display max-w-[10em] pb-10 text-3xl uppercase font-stretch-expanded lg:text-5xl xl:max-w-[10em]"
          />
        </div>
        <div
          :class="[data.layout === 'leftMedia' ? 'hidden' : 'block xl:col-start-4']"
          class="mt-auto xl:col-span-3"
        >
          <ElementsPortableTextWrapper class="pb-7 text-lg" :content="data.subHeading" />
          <ElementsPortableTextWrapper :content="data.text" />
        </div>
      </div>
      <CommonMedia
        :sizes="['80vw', '40vw']"
        class="xl:w-1/2"
        :fill="'both'"
        :aspect="4 / 5"
        :media="data.media"
        :autoplay="true"
        :controls="false"
        :muted="true"
        :loop="true"
      />
    </div>

    <div
      :class="[data.layout === 'leftMedia' ? 'hidden' : 'flex']"
      class="bottom-0 z-2 ml-auto flex h-full w-full items-end xl:absolute xl:right-0 xl:grid xl:w-1/2 xl:grid-cols-6"
    >
      <div
        :class="[data.layout === 'leftMedia' ? 'hidden' : 'flex']"
        class="bottom-0 w-full flex-col xl:sticky xl:col-span-3 xl:col-start-4"
      >
        <ElementsOverlayButton
          v-for="(overlay, index) in data.overlays"
          :key="index"
          :overlay="overlay"
          class="ml-auto"
        />
      </div>
    </div>

    <div
      v-if="data.layout === 'leftMedia'"
      class="xl:gap-gap relative bottom-0 z-2 ml-auto flex h-full w-full flex-col items-end xl:absolute xl:right-0 xl:w-1/2"
    >
      <div class="px-gap mt-auto pb-7 xl:w-1/2 xl:pb-0">
        <ElementsPortableTextWrapper class="pb-7 text-lg" :content="data.subHeading" />
        <ElementsPortableTextWrapper :content="data.text" />
      </div>
      <div
        :class="[data.layout === 'leftMedia' ? 'xl:pl-gap' : '']"
        class="bottom-0 flex w-full flex-col xl:sticky xl:w-1/2"
      >
        <ElementsOverlayButton
          v-for="(overlay, index) in data.overlays"
          :key="index"
          :overlay="overlay"
          class="ml-auto"
        />
      </div>
    </div>
  </section>
</template>
